(function () {
  'use strict';

  function initProductGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;

    var mainImg = gallery.querySelector('[data-product-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-product-gallery-thumb]');
    var lightbox = gallery.querySelector('[data-product-gallery-lightbox]');
    var lightboxImg = gallery.querySelector('[data-product-gallery-lightbox-img]');
    var lightboxClose = gallery.querySelector('[data-product-gallery-lightbox-close]');

    if (!mainImg) return;

    function setActiveThumb(thumb) {
      thumbs.forEach(function (t) {
        var isActive = t === thumb;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function clearActiveThumbs() {
      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-current', 'false');
      });
    }

    function applyImage(options) {
      var src = options.src;
      var srcset = options.srcset;
      var alt = options.alt;
      var imageId = options.imageId;
      var zoomSrc = options.zoomSrc;

      if (!src) return;

      mainImg.classList.add('is-fading');

      window.setTimeout(function () {
        mainImg.src = src;
        if (srcset) {
          mainImg.srcset = srcset;
        } else {
          mainImg.removeAttribute('srcset');
        }
        if (alt) mainImg.alt = alt;
        if (imageId) {
          mainImg.setAttribute('data-image-id', imageId);
        } else {
          mainImg.removeAttribute('data-image-id');
        }
        if (zoomSrc) {
          mainImg.setAttribute('data-zoom-src', zoomSrc);
        }
        mainImg.classList.remove('is-fading');
      }, 120);
    }

    function setFromThumb(thumb) {
      applyImage({
        src: thumb.getAttribute('data-image-src'),
        srcset: thumb.getAttribute('data-image-srcset'),
        alt: thumb.getAttribute('data-image-alt'),
        imageId: thumb.getAttribute('data-image-id'),
        zoomSrc: thumb.getAttribute('data-image-zoom'),
      });
      setActiveThumb(thumb);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setFromThumb(thumb);
      });
    });

    function openLightbox() {
      if (!lightbox || !lightboxImg) return;
      var zoomSrc = mainImg.getAttribute('data-zoom-src') || mainImg.currentSrc || mainImg.src;
      if (!zoomSrc) return;
      lightboxImg.src = zoomSrc;
      lightboxImg.alt = mainImg.alt || 'Enlarged product image';
      lightbox.classList.remove('hidden');
      lightbox.classList.add('flex');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
    }

    function closeLightbox() {
      if (!lightbox || !lightboxImg) return;
      lightbox.classList.add('hidden');
      lightbox.classList.remove('flex');
      lightbox.setAttribute('aria-hidden', 'true');
      lightboxImg.src = '';
      document.body.classList.remove('overflow-hidden');
    }

    mainImg.addEventListener('click', openLightbox);

    if (lightboxClose) {
      lightboxClose.addEventListener('click', closeLightbox);
    }

    if (lightbox) {
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox && lightbox.getAttribute('aria-hidden') === 'false') {
        closeLightbox();
      }
    });

    window.productGallery = {
      setImageUrl: function (url) {
        if (!url) return;

        var matchedThumb = null;
        thumbs.forEach(function (thumb) {
          if (thumb.getAttribute('data-image-src') === url) {
            matchedThumb = thumb;
          }
        });

        if (matchedThumb) {
          setFromThumb(matchedThumb);
          return;
        }

        applyImage({ src: url });
        clearActiveThumbs();
      },
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGallery);
  } else {
    initProductGallery();
  }
})();